import React from 'react';
import { useNavigate } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Button,
  Typography,
} from '@material-ui/core';

const styles = (theme) => ({
  appBar: {
    backgroundColor: 'white',
    borderBottom: '3px solid #1a1a1a',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    padding: '30px 0 20px',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 60px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 20px',
    },
  },
  headerContainer: {
    width: '100%',
    textAlign: 'center',
    borderBottom: '1px solid #e0e0e0',
    paddingBottom: '20px',
    marginBottom: '20px',
  },
  logo: {
    height: '40px',
    '&:hover': {
      cursor: 'pointer',
    }
  },
  logoTypography: {
    color: '#1a1a1a',
    fontSize: '56px',
    fontWeight: 700,
    fontFamily: '"Georgia", serif',
    letterSpacing: '2px',
    '&:hover': {
      cursor: 'pointer',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px',
    },
  },
  logoSpan: {
    color: '#d4145a',
  },
  tagline: {
    fontSize: '14px',
    letterSpacing: '3px',
    textTransform: 'uppercase',
    color: '#666',
    marginTop: '10px',
    fontFamily: '"Segoe UI", sans-serif',
  },
  navMenu: {
    display: 'flex',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    justifyContent: 'center',
    gap: '40px',
    [theme.breakpoints.down('sm')]: {
      display: 'none', // Hide on mobile, would need JS for toggle
    },
  },
  navItem: {
    margin: 0,
  },
  navButton: {
    fontFamily: '"Segoe UI", sans-serif',
    fontWeight: 600,
    color: '#1a1a1a',
    textTransform: 'uppercase',
    fontSize: '14px',
    letterSpacing: '1px',
    transition: 'color 0.3s',
    padding: '8px 0',
    position: 'relative',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#d4145a',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-5px',
      left: '0',
      width: '0',
      height: '2px',
      backgroundColor: '#d4145a',
      transition: 'width 0.3s',
    },
    '&:hover::after': {
      width: '100%',
    },
  },
  activeNavButton: {
    color: '#d4145a',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-5px',
      left: '0',
      width: '100%',
      height: '2px',
      backgroundColor: '#d4145a',
    },
  },
  contactButton: {
    backgroundColor: '#1a1a1a',
    color: '#ffffff',
    padding: '16px 40px',
    textTransform: 'uppercase',
    fontWeight: 600,
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '14px',
    letterSpacing: '1px',
    transition: 'all 0.3s',
    border: '2px solid #1a1a1a',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: 'white',
      color: '#1a1a1a',
    },
  },
  mobileMenuButton: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  }
});

function Header(props) {
  const { classes } = props;
  const navigate = useNavigate();
  
  // Function to scroll to section
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/');
      // Add a small delay to allow the page to load before scrolling
      setTimeout(() => {
        const newElement = document.getElementById(sectionId);
        if (newElement) {
          newElement.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <AppBar position="sticky" elevation={0} className={classes.appBar}>
      <div className={classes.container}>
        <div className={classes.headerContainer}>
          <Typography className={classes.logoTypography} onClick={() => navigate('/')}>Legal<span className={classes.logoSpan}>Sutra</span></Typography>
          <div className={classes.tagline}>Excellence in Legal Services</div>
        </div>
        <nav>
          <ul className={classes.navMenu}>
            <li className={classes.navItem}>
              <Button
                className={classes.navButton}
                onClick={() => scrollToSection('about')}
              >
                About
              </Button>
            </li>
            <li className={classes.navItem}>
              <Button
                className={classes.navButton}
                onClick={() => scrollToSection('practice-areas')}
              >
                Services
              </Button>
            </li>
            <li className={classes.navItem}>
              <Button
                className={classes.navButton}
                onClick={() => scrollToSection('about')}
              >
                Why Us
              </Button>
            </li>
            <li className={classes.navItem}>
              <Button
                className={classes.navButton}
                onClick={() => scrollToSection('testimonials')}
              >
                Testimonials
              </Button>
            </li>
            <li className={classes.navItem}>
              <Button
                className={classes.navButton}
                onClick={() => scrollToSection('cases')}
              >
                Cases
              </Button>
            </li>
            <li className={classes.navItem}>
              <Button
                className={classes.navButton}
                onClick={() => scrollToSection('contact')}
              >
                Contact
              </Button>
            </li>
          </ul>
        </nav>
      </div>
    </AppBar>
  );
}

export default withStyles(styles)(Header);
